import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
const AlreadyHaveAccount = ({
  goLogin,
  classNames,
  pageId,
}: {
  goLogin: () => void;
  classNames?: string;
  pageId: string;
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const code = router?.query?.code as string;

  const handleGoLogin = () => {
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_ModularClick",
      UM_Key_ButtonName: "maillogin",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_ResourceID: code,
    });
    goLogin();
  };
  return (
    <div
      className={`text-[14px] font-['Mulish'] font-[400] text-[#333] text-center  ${classNames}`}
    >
      {t("login.already_hava_account")}
      <span
        onClick={handleGoLogin}
        className="text-[#1677FF] font-[700] cursor-pointer ms-[10px]"
      >
        {t("login.login_in_here")}
      </span>
    </div>
  );
};

export default AlreadyHaveAccount;
